export default [
    ...require('./show').default,
    ...require('./edit').default,
];
